import store from '@/store/store';
import public_routes from './public';
import app_routes from './app';

export const routes = [
  {
    path: '*',
    redirect: '/public/error-404'
  },
  {
    path: '',
    component: () => import('@/layouts/boilerplate/Boilerplate.vue'),
    meta: {
      public: true
    },
    beforeEnter: async (to, from, next) => {
      const root = await store.state.router.apiRoot;
      if (!root) next({name: 'page-maintenance'});
      if (to.matched.length === 1 && to.name !== 'page-maintenance') {
        next({name: 'app-dashboard'});
        return;
      }
      if (!root.$hasLink('private')) {
        if (to.matched.every(r => !!r.meta.public)) {
          next();
        } else {
          next({name: 'page-login'});
        }
      } else {
        next();
      }
    },
    props: () => ({
      apiRoot: store.state.router.apiRoot
    }),
    children: [
      public_routes,
      app_routes
    ]
  }
];
